import script from "./App.vue?vue&type=script&lang=ts&setup=true"
export * from "./App.vue?vue&type=script&lang=ts&setup=true"

import "./App.vue?vue&type=style&index=0&id=5cf4c51e&lang=css"
import "./App.vue?vue&type=style&index=1&id=5cf4c51e&lang=css"

const __exports__ = script;

export default __exports__